import * as React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import useProductName from "brand-customization/useProductName";
const ThrottlingCheckbox = ({ id, defaultChecked, onChange }) => {
  const { t } = useTranslation("integrations");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id,
      type: "checkbox",
      value: "enable-throttling",
      defaultChecked,
      onChange,
      label: t("throttling_checkbox.label"),
      help: t("throttling_checkbox.help", { productName })
    }
  );
};
export default ThrottlingCheckbox;
